// حساب أوقات الإجازة الزمنية تلقائياً حسب النوع والمدة وأوقات دوام الفرع.
const toMin = (hhmm) => {
  const [h, m] = (hhmm || "0:0").split(":").map(Number);
  return h * 60 + m;
};

const fromMin = (mins) => {
  const x = ((mins % 1440) + 1440) % 1440;
  return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`;
};

// start_delay: وقت العودة = بداية الدوام + المدة. early_leave: وقت الانصراف = نهاية الدوام − المدة.
// mid_day يُرجِع null (إدخال يدوي من/إلى).
export const autoTimes = (type, hours, workStart, workEnd) => {
  if (type === "start_delay") return { start_time: "", end_time: fromMin(toMin(workStart) + hours * 60) };
  if (type === "early_leave") return { start_time: fromMin(toMin(workEnd) - hours * 60), end_time: "" };
  return null;
};
